import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneInformationAboutTheScientificFoundation = createAsyncThunk(
  "SU_NT_MRI_InformationAboutTheScientificFoundation/GetOneInformationAboutTheScientificFoundation",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SU_NT_MRI_InformationAboutTheScientificFoundation/GetOneInformationAboutTheScientificFoundation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data,"app");
      return data; // Return the extracted data
      
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const InformationAboutScientificInstitution = createSlice({
  name: "InformationAboutScientificInstitution",
  initialState: {
    InfoScientificFoundation: {},
    loadingInfoScientificFoundation: false,
    errorInfoScientificFoundation: null,
  
  },
  reducers: {setInfoScientificFoundation: (state, action) => {
    state.InfoScientificFoundation = action.payload;
  },
},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneInformationAboutTheScientificFoundation.pending, (state, action) => {
        state.loadingInfoScientificFoundation = true;
        state.InfoScientificFoundation = action.payload;
        state.errorInfoScientificFoundation = null;
      })
      .addCase(GetOneInformationAboutTheScientificFoundation.fulfilled, (state, action) => {
        state.loadingInfoScientificFoundation = false;
        state.InfoScientificFoundation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneInformationAboutTheScientificFoundation.rejected, (state, action) => {
        state.loadingInfoScientificFoundation = false;
        state.InfoScientificFoundation = action.payload;
      })
      
  },
});
export const { setInfoScientificFoundation } =
InformationAboutScientificInstitution.actions;
export default InformationAboutScientificInstitution.reducer;
